<template>
    <div v-bind:class="ContentBlockBaseProps.Class" v-bind:style="ContentBlockBaseProps.Style">
        <div :class="BlockProps.Shadow? 'shadow-sm mb-3' : ''" :style="{'background-color' : BlockProps.BGColor + ' !important'}">
            <div class="container" v-bind:style="ContainerPadding">
                <div class="">

                    <!-- End Heading -->
                    <div class="row row-cols-1 row-cols-lg-2 justify-content-center">
                        <div class="col" v-for="block in BlockProps.Blocks">
                            <div :style="{'background-color' : BlockProps.HighlightColor + ' !important'}" class="mb-6 shadow-sm p-3 rounded-2">
                                <div><propertyiconeditor :inline="true" v-model:icon="block.Icon" :prompt="'Block Icon (click to change)'"></propertyiconeditor>&nbsp;<omnieditor :iseditmode="iseditmode" editortype="tinymce" keyDown v-model="block.Header" style="display:inline" tag-name="h1" :init="EditorConfig" /></div>
                                <omnieditor :iseditmode="iseditmode" editortype="tinymce" class="small" keyDown v-model="block.SubTitle" :init="EditorConfig" />
                            </div>
                            <omnieditor :iseditmode="iseditmode" editortype="tinymce" class="small" keyDown v-model="block.Content" tag-name="div" :init="EditorConfig" />
                        </div>
                        <!-- End Col -->


                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <omnieditor :iseditmode="iseditmode" editortype="tinymce" class="small" keyDown v-model="BlockProps.Footer" tag-name="div" :init="EditorConfig" />
                        </div>
                        <!-- End Row -->
                    </div>
                </div>

            </div>

        </div>

        <div v-if="iseditmode" style="z-index:300" class="modal" :id="'editor' + BlockProps.UId" tabindex="-1" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Options</h5>
                    </div>
                    <div class="modal-body">
                        <hr style="margin: 0px; margin-bottom:10px;" />
                        <propertybaseeditors :blockprops="BlockProps" :additionalcfg="AdditionalCfg"></propertybaseeditors>
                        <propertytogglededitor propertyname="Shadows" :blockprops="BlockProps" prompt="Inner Drop Shadows"></propertytogglededitor>

                        <div class="row">
                            <hr style="margin-top: 10px; margin-bottom:5px;" />
                            <div class="col col-12">
                                <label for="customRange2" class="form-label">Number of Blocks (1 - 6)</label>
                                <div class="input-group mb-3">
                                    <button @click="RemoveBlock" class="btn btn-outline-secondary" type="button">-</button>
                                    <input readonly style="text-align:center;" min="1" max="6" type="number" class="form-control" v-model="NumBlocksUI">
                                    <button @click="AddBlock" class="btn btn-outline-secondary" type="button">+</button>
                                </div>
                                <div class="progress" style="height: 20px;">
                                    <div class="progress-bar" role="progressbar" :style="{'width': NumBlocksUIFilled}" :aria-valuenow="NumBlocksUIFilled" aria-valuemin="0" aria-valuemax="6">{{NumBlocksUI}} / 6</div>
                                </div>
                            </div>

                            <propertycoloreditor :propertyname="'HighlightColor'" :blockprops="BlockProps" :prompt="'Highlight Color'"></propertycoloreditor>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal">Done</button>
                        <!--<button type="button" class="btn btn-sm btn-primary">Save changes</button>-->
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import EventHub from '/src/Util/EventHub.js';
    import ContentBlockBase from '/src/components/ContentCreator/ContentBlockBase.vue'
    import { computed, ref, nextTick } from 'vue'


    export default {
        inheritAttrs: false,
        name: 'FeatureBlocks',
        mixins: [ContentBlockBase],
        props: [],
        components: {

        },
        computed:
        {           
            NumBlocksUIFilled() {
                return `${Math.floor(this.NumBlocksUI / 6 * 100)}%`;
            }
        },
        data() {
            return {  
                NumBlocksUI: 3
            };
        },
        watch: {
            NumBlocksUI: function (newVal, oldVal) {

                while (newVal < this.BlockProps.Blocks.length) {
                    this.BlockProps.Blocks.pop();
                }

                while (newVal > this.BlockProps.Blocks.length) {
                    var newBlock = JSON.stringify(this.Store.DefaultBlockProps[this.ComponentType].Blocks[0]);
                    newBlock = JSON.parse(newBlock)
                    this.BlockProps.Blocks.push(newBlock);
                }
            }
        },
        methods:
        {
            AddBlock: function () {
                this.NumBlocksUI = Math.min(this.NumBlocksUI + 1, 6);
            },
            RemoveBlock: function () {
                this.NumBlocksUI = Math.max(this.NumBlocksUI - 1, 1);
            },
            EditProperties: function () {
                var id = '#editor' + this.BlockProps.UId;
                var modalEl = document.querySelector(id);
                if (modalEl == null) {
                    return;
                }
                var modal = bootstrap.Modal.getOrCreateInstance(modalEl); // Returns a Bootstrap modal instance
                modal.show();
            },
            
        },

        setup(props, context)
        {             
            return {} // anything returned here will be available for the rest of the component
        },
        created()
        {           
            
        },
        beforeUnmount()
        {
            
        },
        mounted() {
            nextTick().then(() => {
         
            });
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>

